// extracted by mini-css-extract-plugin
export var banner = "t_ct";
export var bannerRight = "t_cv";
export var contentWrap = "t_n";
export var heading = "t_p";
export var content = "t_cw";
export var ctaWrap = "t_w";
export var image = "t_cx";
export var imageWrap = "t_cy";
export var imageWrap_inner = "t_cz";